<template>
	<div class="groupFields" :style="{ margin, padding, width }">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "GroupFields",
	props: {
		margin: {
			type: String,
			default: () => '0'
		},
		padding: {
			type: String,
			default: () => '20px'
		},
		width: {
			type: String,
			default: () => '100%'
		}
	}
};
</script>

<style scoped lang="scss">
.groupFields {
	background: var(--card-bg-opacity);
	display: flex;
	flex-direction: column;
	gap: 10px;
}
</style>
